export default "__VITE_ASSET__DfBKU01D__$_?component__"